module.exports = __webpack_public_path__ + "static/media/hear_results_2.2530eb43.jpg";